import React from "react";
import { Navigate } from "react-router-dom";
import { connect } from "react-redux";
import LoadingScreen from "../../../toolkit/loadingScreen";

interface Props {
  children: React.ReactNode;
  isLoggedIn: boolean;
  isRehydrated: boolean;
}

const ProtectedRoute: React.FC<Props> = ({
  children,
  isLoggedIn,
  isRehydrated,
}) => {
  if (!isRehydrated) {
    return <LoadingScreen />;
  }

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

const mapStateToProps = state => {
  const { user, _persist } = state;
  return {
    isLoggedIn: user.isLoggedIn,
    isRehydrated: _persist?.rehydrated ?? false,
  };
};

export default connect(mapStateToProps)(ProtectedRoute);
